import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MomentModule } from 'angular2-moment';
import { SharedModule } from 'app/shared/shared.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { ChatsModule } from '../chats/chats.module';
import { FeedbackAssignmentComponent } from './feedback-assignments/feedback-assignment/feedback-assignment.component';
import { FeedbackAssignmentsComponent } from './feedback-assignments/feedback-assignments.component';
import { FeedbackDetailComponent } from './feedback-detail/feedback-detail.component';
import { FeedbackEditComponent } from './feedback-edit/feedback-edit.component';
import { FeedbacksComponent } from './feedbacks.component';
import { FeedbacksRoutingModule } from './feedbacks.routing.module';
import { FeedbacksService } from './shared/feedbacks.service';

@NgModule({
  imports: [
    CommonModule,
    FeedbacksRoutingModule,
    FormsModule,
    MomentModule,
    SharedModule,
    HttpClientModule,
    ChatsModule,
    InfiniteScrollModule
  ],
  providers: [
    FeedbacksService
  ],
  declarations: [
    FeedbacksComponent,
    FeedbackDetailComponent,
    FeedbackEditComponent,
    FeedbackAssignmentsComponent,
    FeedbackAssignmentComponent
  ]
})
export class FeedbacksModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/feedbacks/feedbacks.module.ts